"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightDateTime = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
const dateTimeFormat_1 = require("../../../../../utils/dateTimeFormat");
const Tooltip_1 = require("../../../../Tooltip");
const WeekDay_1 = require("../../../../WeekDay");
require("./index.scss");
const className = 'flight-list-datetime';
const FlightDateTime = (props) => {
    const { value, departed, delayed, cancelled, onlyTime, onlyDate, modificators, } = props;
    const datetime = moment_1.default.parseZone(value);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        cancelled ? 'color-red' : undefined,
        departed ? 'color-green' : undefined,
        delayed ? 'color-orange' : undefined,
    ]);
    const tooltipRows = [
        cancelled
            ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Item/DateTime:Cancelled', defaultMessage: 'Flight is cancelled' })) : undefined,
        delayed
            ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Item/DateTime:Delayed', defaultMessage: 'Flight is delayed' })) : undefined,
        departed
            ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Item/DateTime:Flied', defaultMessage: 'Flight is departed' })) : undefined,
    ].filter(Boolean);
    const Content = (react_1.default.createElement(react_1.default.Fragment, null,
        !onlyTime && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(WeekDay_1.WeekDay, { name: datetime, modificators: 'margin-right' }),
            react_1.default.createElement("span", { className: `${className}__date` }, datetime.format(dateTimeFormat_1.DATE_FORMAT)))),
        !onlyDate && (react_1.default.createElement("div", { className: `${className}__time` }, datetime.format(dateTimeFormat_1.TIME_FORMAT)))));
    return (react_1.default.createElement("div", { className: classNames }, tooltipRows.length > 0 && (react_1.default.createElement(Tooltip_1.Tooltip, { text: react_1.default.createElement(react_1.default.Fragment, null, tooltipRows.map((row, idx) => (react_1.default.createElement("div", { key: idx }, row)))), modificators: 'white' }, Content)) || (Content)));
};
exports.FlightDateTime = FlightDateTime;
//# sourceMappingURL=index.js.map